import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {getLayerByName, removeLayer, removeLayersIncludes, visibleLayersIncludes} from "@/helpers/ol/ol-layer-helper";
import {getDefaultSelectStyleFunction, getDefaultStyleFunction} from "@/helpers/ol/ol-style-helper";
import {setMapClickMarker} from "@/helpers/ol/ol-map-click-layer-helper";
import {transform} from "ol/proj";
import {getMeasureLayerStyleFunction} from "@/helpers/tools/tools-measure-helper";
import {GeoJSON} from "ol/format";

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";

/**
 * Params
 * @type {string}
 */
const defaultName = 'activeGeoJson'

/**
 * clearGeoJsonLayers()
 */
export function clearGeoJsonLayers() {
    removeLayersIncludes(defaultName)
}

/**
 * removeGeoJsonLayer()
 *
 * @param formID
 * @param index
 */
export function removeGeoJsonLayer(formID, index = '') {
    let name = defaultName

    if(formID !== '') {
        name += '-' + formID
    }

    if(index !== '') {
        name += '-' + index
    }

    removeLayer(name, false)
}

/**
 * setVisibleLayersIncludes()
 *
 * @param visible
 */
export function setVisibleLayersIncludes(visible = false) {
    visibleLayersIncludes(defaultName, visible)
}

/**
 * toggleGeoJsonLayer()
 *
 * @param formID
 * @param index
 * @param visible
 */
export function toggleGeoJsonLayer(formID, index = '', visible = null) {
    // console.log('toggleGeoJsonLayer')
    let name = defaultName

    if(formID !== '') {
        name += '-' + formID
    }

    if(index !== '') {
        name += '-' + index
    }

    const layer = getLayerByName(name, false)

    if(layer) {
        if (visible === null) {
            layer.setVisible(!layer.getVisible())
        } else {
            layer.setVisible(visible)
        }
    }
}

/**
 * setGeoJsonLayerSegments()
 *
 * @param formID
 * @param index
 * @param active
 */
export function setGeoJsonLayerSegments(formID, index = '', active = true) {
    let name = defaultName

    if(formID !== '') {
        name += '-' + formID
    }

    if(index !== '') {
        name += '-' + index
    }

    const layer = getLayerByName(name, false)
    if(layer) {
        if(active) {
            layer.setStyle(getDefaultSelectStyleFunction())
        } else {
            layer.setStyle((feature) => {
                return getMeasureLayerStyleFunction(feature, true, undefined, undefined);
            })
        }
    }
}

/**
 * createGeoJsonLayer()
 *
 * @param feature
 * @param formID
 * @param visible
 * @param name
 * @param styleFunction
 * @param dataProjection
 * @param zIndex
 * @returns {VectorLayer<VectorSource>}
 */
export function createGeoJsonLayer(feature, formID = '', visible = true, name = '', styleFunction = getDefaultSelectStyleFunction(), dataProjection = 'EPSG:28992', zIndex = 10000) {

    let features
    if(feature.type === 'FeatureCollection') {
        features = new GeoJSON({
            dataProjection: dataProjection,
            featureProjection: getViewProjectionName()
        }).readFeatures(feature)
    } else {
        // Return when no geometry
        if (!feature.geometry) {
            return
        }
        features = generateGeoJsonObjectFromFeature(feature)
    }

    if(!name) {
        name = defaultName
    }
    if(formID !== '') {
        name += '-' + formID
    }
    const vectorSource = new VectorSource({
        features: features,
    });

    const vectorLayer = new VectorLayer({
        name: name,
        source: vectorSource,
        style: styleFunction,
        // style: styleFunction,
        visible: visible,
        altitudeMode: 'clampToGround',
        zIndex: zIndex
    });

    console.log('add layer')

    window.map.addLayer(vectorLayer)

    return vectorLayer
}

/**
 * generateGeoJsonObjectFromFeature()
 *
 * @param feature
 * @param convert
 * @returns {Array<import("../Feature.js").default>}
 */
export function generateGeoJsonObjectFromFeature(feature, convert = true) {
    const geoJson = {}

    if(feature) {
        geoJson.type = 'FeatureCollection'
        geoJson.features = []
        feature.type = 'Feature'

        let options = {}
        if (convert && feature.projection !== getViewProjectionName()) {
            options = {
                dataProjection: feature.projection,
                featureProjection: getViewProjectionName()
            }
        }
        if(feature.projection) {
            if(!feature.properties) {
                feature.properties = {}
            }
            feature.properties.kv_projection = feature.projection
        }

        if(!feature.id) {
            feature.id = feature.featureid
        }
        if(feature.geometry && !feature.geometry.type) {
            feature.geometry.type = feature.geometry.Type
        }

        geoJson.features.push(feature)
        try {
            let result =  new GeoJSON(options).readFeatures(geoJson)

            return result
        } catch (exception) {
            if (feature.geometry.Type === 'Point') {
                setMapClickMarker(transform(feature.geometry.coordinates, 'EPSG:28992', getViewProjectionName()))
            }
        }
    }
}

export function getGeoJsonLayers() {
    return window.map.getLayers().getArray().filter(layer => {
        return layer.get('name').includes(defaultName)
    })
}
